<template>
  <div class="search">
    <header class="header flex">
      <div class="car-type flex">
        <div class="car-type-box"
          :class="{'yellow-active' : searchForm.type === 2}"
          @click="carTypeChange(2)"
        >黄牌</div>
        <div
          class="car-type-box"
          :class="{'blue-active' : searchForm.type === 1}"
          @click="carTypeChange(1)"
        >蓝牌</div>
      </div>
      <div class="input-search flex">
        <input ref="vclNoInput"
          disabled
          v-model="searchForm.vclNo"
          :placeholder="searchForm.type === 1 ? '请输入货车车牌号(部分可查)' : '请输入货车车牌号'"
          type="text" />
        <div class="input-clear" v-if="searchForm.vclNo.length>0" @click.stop="searchForm.vclNo = ''">
          <svg
              t="1569295637029"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8743"
              width="14" height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <path
                d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512S794.763636 1024 512 1024zM512 46.545455C254.929455 46.545455 46.545455 254.929455 46.545455 512s208.384 465.454545 465.454545 465.454545 465.454545-208.384 465.454545-465.454545S769.070545 46.545455 512 46.545455z"
                p-id="8744"
                fill="#989898">
              </path>
              <path d="M709.469091 281.623273l32.907636 32.907636L314.530909 742.376727l-32.907636-32.907636L709.469091 281.623273z"
                p-id="8745"
                fill="#989898">
              </path>
              <path d="M314.530909 281.623273l427.869091 427.869091-32.907636 32.907636L281.623273 314.530909 314.530909 281.623273z"
                p-id="8746"
                fill="#989898">
              </path>
          </svg>
        </div>
      </div>
      <div @click="goSearchCar" class="operation flex">搜索</div>
    </header>
    <section class="history">
      <header class="history-header flex">
        <div>历史车牌</div>
        <div @click="allDeleteBtn" v-if="plateList.length">全部删除</div>
      </header>
      <div class="plate-list flex" v-if="plateList.length">
        <div class="plate flex" @click="selectHistoryBtn(item)" v-for="item in plateList" :key="item.id">
          <div class="plate-number" :class="[item.vco===2 ? 'yellowplate' : 'blueplate']">
            {{item.vno}}
          </div>
          <svg
            @click="deleteVcln(item.id, item)"
            t="1569295637029"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8743"
            width="16" height="16"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <path
              d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512S794.763636 1024 512 1024zM512 46.545455C254.929455 46.545455 46.545455 254.929455 46.545455 512s208.384 465.454545 465.454545 465.454545 465.454545-208.384 465.454545-465.454545S769.070545 46.545455 512 46.545455z"
              p-id="8744"
              fill="#989898">
            </path>
            <path d="M709.469091 281.623273l32.907636 32.907636L314.530909 742.376727l-32.907636-32.907636L709.469091 281.623273z"
              p-id="8745"
              fill="#989898">
            </path>
            <path d="M314.530909 281.623273l427.869091 427.869091-32.907636 32.907636L281.623273 314.530909 314.530909 281.623273z"
              p-id="8746"
              fill="#989898">
            </path>
          </svg>
          <div class="rightxian"  v-if="item.active"></div>
        </div>
      </div>
    </section>
    <truck-keyboard  :vclNo="searchForm.vclNo" @deletevclNo="keyBoardDeletevclNo" @confirm="getkeyBoard" @searchBtn='goSearchCar'></truck-keyboard>
    <confirm-dialog ref="ConfirmDialog"
      :message='confirmMessage'
      :confirmButtonText="'是'"
      :cancelButtonText="'否'"
      @confirm=confirmDialogBtn
    >
    </confirm-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Toast } from 'vant'
import TruckKeyboard from '../../components/truckKeyboard'
import ConfirmDialog from '../../components/dialog/ConfirmDialog'
import { getUrlParam } from '../../utils'
import { getSearchHistoryVcln, deleteAllHistoryVcln } from '../../api/searchCar'
// import { exposureUv } from '../../api/elevenActivity'
import { ttRaLunch } from '../../utils/ByteDanceUtil'

export default {
  props: {},
  data () {
    return {
      searchForm: {
        type: 2, // 1为蓝牌 2为黄牌
        vclNo: '' // 车牌号
      },
      confirmMessage: '是否删除全部车牌',
      plateList: []
    };
  },
  computed: {
    ...mapGetters({
      vno: 'hisTrack/vno',
      platform: 'platform'
    })
  },
  created () {},
  mounted () {
    this.bindvclNo()
    this.gethistoryList()
    // this.$refs.vclNoInput.focus()
  },
  watch: {},
  methods: {
    ...mapMutations(['REFRESH_USER_PLATFORM']),

    /**
     * 绑定车牌以及车牌号
    */
    bindvclNo () {
      const vno = getUrlParam('vno')
      const type = getUrlParam('type')
      const platform = getUrlParam('platform')
      if (vno) this.searchForm.vclNo = vno
      if (type) this.searchForm.type = Number(type)
      if (platform) this.REFRESH_USER_PLATFORM({platform})
    },

    /**
     * 设置历史记录
    */
    async gethistoryList () {
      const response = await getSearchHistoryVcln ()
      if (response) {
        const { data, isSuccess} = response
        if (isSuccess) {
          this.plateList = data.map((item, index) => {
            let mainder = index%3
            item.active = false
            if (mainder === 0 || mainder === 1) {
              item.active = true
            }
            return item
          })
        } else {
          this.plateList = []
        }
      }
    },

    /**
     * @param type 0为黄牌 1为蓝牌
    */
    carTypeChange (type) {
      this.searchForm.type = type
    },

    /**
     * @param item 键盘穿过来的值
    */
    getkeyBoard (item) {
      const { vclNo } = this.searchForm
      this.searchForm.vclNo = `${vclNo}${item}`
    },

    /**
     * 去搜索车
    */
    goSearchCar () {
    //   this.setCensusUv()
      const { type, vclNo } = this.searchForm
      if (vclNo.length < 7) {
        Toast('请输入正确的车牌号')
        return
      }
      const params = `?vno=${vclNo}&type=${type}`
      if (this.platform === 'TENCENT_QQ_VEHICLE') {
        qq.miniProgram.reLaunch({
          url: `../../index/index${params}`
        });
      } else if(this.isBytedance) {
        ttRaLunch(`/pages/index/index${params}`)
      }
    },

    /**
     * 键盘删除车牌号
    */
    keyBoardDeletevclNo () {
      const { vclNo } = this.searchForm
      this.searchForm.vclNo = vclNo.substring(0, vclNo.length-1)
    },

    /**
     * 全部删除车牌号
    */
    allDeleteBtn () {
      this.$refs.ConfirmDialog.showPopup()
    },

    /**
     * 确认删除全部历史记录
    */
    async confirmDialogBtn () {
      const vnoId = this.plateList.map(item => item.id).join(',')
      const response = await deleteAllHistoryVcln(vnoId)
      if (response) {
        const { isSuccess } = response
        if (isSuccess) {
          this.gethistoryList()
        }
      }
    },

    /**
     * 删除车牌
     * id 车牌号id
    */
    async deleteVcln (id, item) {
      const response = await deleteAllHistoryVcln(id)
      if (response) {
        const { isSuccess } = response
        if (isSuccess) {
          if (item.vno === this.searchForm.vclNo) {
            this.searchForm.vclNo = ''
          }
          this.gethistoryList()
        }
      }
    },

    /**
     *
     * 选择历史车牌
    */

    selectHistoryBtn (item) {
      this.searchForm = {
        vclNo : item.vno,
        type : Number(item.vco)
      }
    },

    /**
     *
     *
     * 添加查车查询uv
    */
    // async setCensusUv() {
    //   await exposureUv(92)
    // },
  },
  components: {
    TruckKeyboard,
    ConfirmDialog
  }
};
</script>

<style scoped lang="scss">
.search {
  width: 100%;
  height: 100%;
  background-color: #F2F2F2;
  position: relative;
  overflow-x: hidden;
  .flex {
    display: flex;
  }
  .header {
    width: 100%;
    background-color: #ffffff;
    padding: 10px 20px;
    justify-content: space-between;
    left: 0;
    top: 0;
    .car-type {
      // padding: 10px 20px;
      height: 60px;
      line-height: 60px;
      font-size: 26px;
      font-weight: 500;
      text-align: center;
      width: 180px;
      background: rgba(229, 229, 229, 1);
      border-radius: 6px 6px 3px;
      z-index: 99;
      .car-type-box {
        flex: 1;
        height: 60px;
        text-align: center;
        color: #656565;
      }
      .yellow-active {
        background: rgba(247, 201, 68, 1);
        box-shadow: 2px 0 4px 0 rgba(176, 176, 176, 0.74);
        border-radius: 6px;
      }
      .blue-active {
        background: rgba(85, 114, 253, 1);
        box-shadow: 2px 0 4px 0 rgba(176, 176, 176, 0.74);
        border-radius: 6px;
        color: #ffffff;
      }
    }
    .input-search {
      flex: 1;
      padding-left: 20px;
      position: relative;
      align-items: center;
      input {
        width: 80%;
        font-size: 28px;
        height: 40px;
        line-height: 40px;
        color: #282828;
        background-color: #ffffff;
      }
      input::-webkit-input-placeholder {
        color: #CCCCCC;
        -webkit-text-fill-color: #CCCCCC;
        -webkit-opacity:1;
        opacity: 1;
      }
      input[disabled] {
        color: #282828;
        -webkit-text-fill-color:#282828;
        -webkit-text-fill-color:#282828;
        -webkit-opacity:1;
        opacity: 1;
      }
      .input-clear {
        position: absolute;
        right: 30px;
      }
    }
    .operation {
      position: relative;
      align-items: center;
      padding-right: 50px;
      color: #5572FD;
    }
  }
  .history {
    margin-top: 20px;
    padding: 20px;
    background-color: #ffffff;
    .history-header {
      justify-content: space-between;
      font-size: 22px;
      :last-child {
        color: #FF3C3C;
      }
      :first-child {
        color: #282828;
        font-weight: bold;
      }
    }
    .plate-list {
      padding-top: 30px;
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      flex-wrap: wrap;
      display: flex;
      .plate {
        width: 33%;
        align-items: center;
        margin-right: 0px;
        position: relative;
        margin-bottom: 10px;
        margin-right: 0px;
        .plate-number {
          width: 60%;
          padding: 10px 10px;
          font-size: 20px;
          text-align: center;
          border: 1px solid rgba(40, 40, 40, 1);
          border-radius: 6px;
          font-weight: bold;
        }
        svg {
          margin-left: 10px;
          margin-right: 6px;
        }
        .rightxian {
          width: 1px;
          height: 40px;
          background-color: #E5E5E5;
          position: absolute;
          right: 16px;
        }
        .yellowplate {
          background-color: #FFCB26;
          color: #282828;
        }
        .blueplate {
          background-color: #5572FD;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
